// extracted by mini-css-extract-plugin
export var option = "_4k-1";
export var optionActive = "_4k-2";
export var pill = "_4k-0";